import STRINGS from "../globals/strings";
import IMAGES from "../globals/images";
import "../styles/crick.css";
import "../styles/livesummary.css";

const LiveSummary = ({ summaryDataLive, openPopup }) => {
  const { batsman_data, bowler_data, result, inning_total, team_name, team_image, match_message } = summaryDataLive || {};

  const getTeamImageUrl = (summaryDataLive) => {
    const teamImage = summaryDataLive.team_image;
    const teamName = summaryDataLive.team_name;
    if (teamImage && teamImage.charAt(teamImage.length - 1) === '/') {
      return teamName ? `${teamImage}${teamName.replace(/\s+/g, '_')}` : IMAGES.PHOENIX_LOGO;
    }
    return teamImage || IMAGES.PHOENIX_LOGO;
  }

  if (!summaryDataLive) {
    return <div>...Loading summary data...</div>;
  }

  return (
    <div className="summary">
      <div className='live-team-row'>
        <div
          className='live-team'
          style={{ borderRadius: "20px 0 0 20px" }}
        >
          <img src={getTeamImageUrl(team_image)} alt={STRINGS.TEAM1_LOGO_ALT} className="live-team-logo" />
          <div className="live-team-content" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <label className="live-team-name">{team_name}</label>
              {result ? (
                <span style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                  <label className="live-team-balls">
                    Need <b style={{ color: "#2EA850" }}>{result?.need_runs}</b> runs in <b style={{ color: "#2EA850" }}>{result?.remain_balls}</b> balls
                  </label>
                </span>
              ) : (
                match_message && <label className="live-team-balls">{match_message}</label>
              )}
            </div>
          </div>
        </div>
        <div
          className='live-team'
          style={{ textAlign: "right", borderRadius: "0 20px 20px 0", direction: "rtl" }}
        >
          <label className="live-team-score">{inning_total?.total_runs}-{inning_total?.total_wickets}</label>
          <div className="live-team-content" style={{ display: "flex", alignItems: "right", justifyContent: "space-between", marginTop: "8px" }}>
            <div>
              <label className="live-team-name" style={{ justifyContent: "flex-start", marginTop: "6px", fontSize: "18px", fontWeight: "500", color: "#030311" }}>
                ( {inning_total?.match_overs} / {inning_total?.overs} )
              </label>
              <span style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                <label className="live-team-over" style={{ marginTop: "6px", fontSize: "14px", fontWeight: "500" }}>
                  <span style={{ color: "#717171" }}>CRR - </span>{inning_total?.current_run_rate?.toFixed(2) || 0}
                </label>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="scorecard" style={{ backgroundColor: "#FFFFFF" }}>
        <table className="summary-best-performance-batsman">
          <thead style={{ backgroundColor: "#FFFFFF" }}>
            <tr>
              <th style={{ textAlign: "left", borderTopLeftRadius: "20px" }}>{STRINGS.BATSMAN_HEADER}</th>
              <th style={{ textAlign: "right" }}>{STRINGS.RUNS_HEADER}</th>
              <th style={{ textAlign: "right" }}>{STRINGS.BALLS_HEADER}</th>
              <th style={{ textAlign: "right" }}>{STRINGS.FOURS_HEADER}</th>
              <th style={{ textAlign: "right" }}>{STRINGS.SIXES_HEADER}</th>
              <th style={{ textAlign: "right", borderTopRightRadius: "20px" }}>{STRINGS.STRIKE_RATE_HEADER}</th>
            </tr>
          </thead>
          <tbody>
            {batsman_data?.length > 0 ? (
              batsman_data.map((batter, index) => (
                <tr key={index}>
                  <td className="name" style={{ textAlign: 'left', verticalAlign: 'top' }}>
                    {`${batter.first_name} ${batter.last_name || ''}`.trim()}
                    {batter.is_out === 0 ? '*' : ''}
                  </td>
                  <td style={{ textAlign: 'right', color: '#030311', fontSize: '16px', fontWeight: '500' }}>
                    {batter.total_run || 0}
                  </td>
                  <td style={{ textAlign: 'right', color: '#030311', fontSize: '16px', fontWeight: '500' }}>
                    {batter.total_ball || 0}
                  </td>
                  <td style={{ textAlign: 'right', color: '#717171', fontSize: '16px', fontWeight: '500' }}>
                    {batter.total_fours || 0}
                  </td>
                  <td style={{ textAlign: 'right', color: '#717171', fontSize: '16px', fontWeight: '500' }}>
                    {batter.total_sixes || 0}
                  </td>
                  <td style={{ textAlign: 'right', color: '#717171', fontSize: '16px', fontWeight: '500' }}>
                    {batter.strike_rate?.toFixed(2) || 0}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="batter-cell" style={{ textAlign: 'center' }}>
                  {STRINGS.NO_TOP_BATSMEN}
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <table className="summary-best-performance-bowler">
          <thead style={{ backgroundColor: "#FFFFFF" }}>
            <tr>
              <th style={{ textAlign: "left" }}>{STRINGS.BOWLER_HEADER}</th>
              <th style={{ textAlign: "right" }}>{STRINGS.OVERS_HEADER}</th>
              <th style={{ textAlign: "right" }}>{STRINGS.MAIDENS_HEADER}</th>
              <th style={{ textAlign: "right" }}>{STRINGS.RUNS_HEADER}</th>
              <th style={{ textAlign: "right" }}>{STRINGS.WICKETS_HEADER}</th>
              <th style={{ textAlign: "right" }}>{STRINGS.ECONOMY_HEADER}</th>
            </tr>
          </thead>
          <tbody>
            {bowler_data?.length > 0 ? (
              bowler_data.map((bowler, index) => (
                <tr key={index}>
                  <td
                    className="name"
                    style={{ textAlign: 'left', cursor: 'pointer' }}
                    onClick={() => openPopup({ ...bowler, bowler_name: `${bowler.first_name} ${bowler.last_name || ""}`.trim() }, 1, team_name)}
                  >
                    {`${bowler.first_name} ${bowler.last_name || ''}`.trim()}
                    {openPopup && (
                      <img
                        src={IMAGES.VECTOR2}
                        alt={STRINGS.BOWLER_DROPDOWN_ALT}
                        className="bowler-dropdown"
                      />
                    )}
                  </td>
                  <td style={{ textAlign: 'right', color: '#030311', fontSize: '16px', fontWeight: '500' }}>
                    {bowler.total_over || 0}
                  </td>
                  <td style={{ textAlign: 'right', color: '#717171', fontSize: '16px', fontWeight: '500' }}>
                    {bowler.total_maiden_over || 0}
                  </td>
                  <td style={{ textAlign: 'right', color: '#717171', fontSize: '16px', fontWeight: '500' }}>
                    {bowler.total_run || 0}
                  </td>
                  <td style={{ textAlign: 'right', color: '#030311', fontSize: '16px', fontWeight: '500' }}>
                    {bowler.total_wicket || 0}
                  </td>
                  <td style={{ textAlign: 'right', color: '#717171', fontSize: '16px', fontWeight: '500' }}>
                    {bowler.economy?.toFixed(2) || 0}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center' }}>
                  No bowling data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LiveSummary;